

// gobal variables
var pageScrollPos = 0;

function getPivotArray(dataArray, rowIndex, colIndex, dataIndex) {
        //Code from https://techbrij.com
        var result = {}, ret = [];
        var newCols = [];
        for (var i = 0; i < dataArray.length; i++) {

            if (!result[dataArray[i][rowIndex]]) {
                result[dataArray[i][rowIndex]] = {};
            }
            result[dataArray[i][rowIndex]][dataArray[i][colIndex]] = dataArray[i][dataIndex];

            //To get column names
            if (newCols.indexOf(dataArray[i][colIndex]) == -1) {
                newCols.push(dataArray[i][colIndex]);
            }
        }

        newCols.sort();
        console.log("columns")
        console.log(newCols)
        var item = {};

        //Add Header Row
        //item.push('Exchange');
        //item.push.apply(item, newCols);


        //ret.push(item);

        //Add content
        for (var key in result) {
            item = {};
            item[rowIndex] = key
            //item.push(key);
            for (var i = 0; i < newCols.length; i++) {
                item[newCols[i]] = result[key][newCols[i]] || "-";
                //item.push(result[key][newCols[i]] || "-");
            }
            ret.push(item);
        }
        return ret;
    }

function setQuantity(thiss) {
  $('input[name=quantity]').val($(thiss).text());
  console.log($(thiss).text());

}

class PositionTable extends DataTable {

  constructor(table_id) {


    super(table_id, false);
    var self = this;
    this.data = false;
    this.paging = false;
    this.columns = []

    this.useJsData = true;
    // this.domstr = "<'row't>" +
    // "<'row'<'col-sm-5'l><'col-sm-5'p>>"
    this.domstr = "<'row't>"// +
    //"<'row'<'col-sm-5'l><'col-sm-5'p>>"
    this.footerCallback = function(row, data, start, end, display ) {
      console.log("footerCallback");
      console.log(data);


       var api = this.api(), data;
       var total1 = api
                .column( 1 )
                .data()
                .reduce( function (a, b) {
                  var a = Number(a) || 0;
                  var b = Number(b) || 0;
                  if (typeof a !== "number") {
                    a = 0
                 }
                 if (typeof b !== "number") {
                   b = 0
                }
                    return a + b;
                }, 0 );

      var total2 = api
               .column( 2 )
               .data()
               .reduce( function (a, b) {
                 var a = Number(a) || 0;
                 var b = Number(b) || 0;
                 if (typeof a !== "number") {
                   a = 0
                }
                if (typeof b !== "number") {
                  b = 0
               }
                   return a + b;
               }, 0 );

        // var footer = $(this).append(`<hr><tfoot><tr style="font-weight:bold;">
        // <th>Totals</th><th>${total1}</th><th>${total2}</th></tr></tfoot>`);
        $( api.column( 1 ).footer() ).html('<a onclick=setQuantity(this)>' +
                total1.toFixed(10)+ '</a> '
            );
            $( api.column( 2 ).footer() ).html('<a onclick=setQuantity(this)>' +
                    total2.toFixed(10)+ '</a>'
                );
            // $( api.column( 2 ).footer() ).html(
            //         total2
            //     );
    }

    this._fetchData().then(function(data) {
      self.setupFilters();

    });




    //this.setupTable();


  }
  ordering() {
    return [[ 1, "desc" ]]
  }

  rowCallback(row, data) {

  }

  getTableColumns() {
    var currencies = $('#id_currency_pair').val().split('-')
    var columnArray = [
                { "data": "exchange", "title": "Exchange" },

            ]
    for (var idx in currencies) {
      columnArray.push({"data": currencies[idx], "title": currencies[idx],
                        "render": function(data, type, row) {
                          return "<a onclick=setQuantity(this)>" + data + "</a>"
                        }});
    }
    console.log(columnArray);
    this.columns = columnArray;
    return columnArray
    }

  _filterData() {
    var currencies = $('#id_currency_pair').val().split('-');
    var md_exchanges = new Set($('#id_market_data_exchanges').val());
    var exchanges = new Set($('#id_exchanges').val());

    var filteredArray = this.rawdata.filter(function(itm){
        return (currencies.indexOf(itm.currency) > -1) && exchanges.has(itm.exchange);
    });
    return getPivotArray(filteredArray,'exchange','currency','amount');

  }

  _fetchData() {
      var self = this;
      var orderPromise = new Promise(function(resolve, reject) {
      var strategy = $('#id_strategy').val();
      var url = '/api/currency_balances/'
      if (strategy) {
        var url = '/api/currency_balances/?strategy=' + strategy
      }
      $.ajax({
                 type: "GET",
                 url: url,
                 success: function(data) {

                   self.rawdata = data;
                   self.data = self._filterData(data);
                   self.getTableColumns(); // Set table columns
                   resolve(data);

                 },
                 error: function(data)
                 {
                    throw new Error(data);
                    console.log(data);
                    console.log("error in render")
                 }
               });


    });
    return orderPromise


  }

  _getTableAjax() {
    return this.data;
  }



  // adds filters to the dom and sets up event handlers and state
  setupFilters() {
    console.log("setting up filters");
    //this.addOrderFilters('');
    // Reconsile mode switch
    this.enableSORRefresh = true;
    var self = this;
    $('#id_currency_pair, #id_exchanges, #id_market_data_exchanges, #id_strategy').on('change', function() {
      console.log("position table currency change");
      self.refresh();

      //self.refresh();
    });

    setInterval(function(){
    self.refresh();
    }, 10000);


  }

  refresh(force) {
    var self = this;
    self._fetchData().then(function(data) {
      if ($('#id_currency_pair').val()) {
      if ( $.fn.dataTable.isDataTable( self.table_id ) ) {
        console.log("destroying dt");
        self.table.destroy();

        }
      self.setupTable();

    } else {
      console.log("no currency pair for position");
    }
  });
      //this.table.ajax.reload( null, false );



  }




}
